﻿window.cBuilderEmailWidgetCtrlTextBoxNomCon = function cBuilderEmailWidgetCtrlTextBoxNomCon(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTextBox.call(this, option);

    this.nomWidget = "dxwidgetformtextboxnomcon"
    this.typChamp = "nom_con";
    this.nomBt = "Nom contact";
    this.titleBt = "Nom d'un contact<br/>Ce champ pourra être relié à votre base de données"
    this.labelCtrl = "Nom contact"

};